import { render, staticRenderFns } from "./dataPermissionModal.vue?vue&type=template&id=c6c124ce&scoped=true"
import script from "./dataPermissionModal.vue?vue&type=script&lang=js"
export * from "./dataPermissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c124ce",
  null
  
)

export default component.exports